export const dependentDropdownOptions = [
  { label: "Spouse", value: "spouse" },
  { label: "Child", value: "child" },
  { label: "Parent", value: "parent" },
  { label: "Parent in Law", value: "parent-in-law" },
];
